<template>
    <div class="qksm qksm10">
        <h4>十、政府性基金预算财政拨款收入支出决算情况说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}2020年政府性基金预算财政拨款年初结转和结余{{isMoney(T10.年初结转结余)}}万元，本年收入决算{{isMoney(T10.本年收入决算)}}万元，
                本年支出决算{{isMoney(T10.本年支出决算)}}万元，年末结转和结余{{isMoney(T10.年末结转和结余)}}万元。
                <template v-if="T10.items.length>0">
                    具体支出情况如下：
                </template>
            </p>
            <p v-for="(item,idx) in T10.items">
                {{T10.items.length>1 ? idx+1+". " :""}}{{item.lei}}{{item.kuan}}{{item.xiang}}支出决算{{isMoney(item.value)}}万元，
                主要是用于<reason type="textarea" classname="qksm widest" :name="item.code+'政府基金用于'" v-model:value="qksm[item.code+'政府基金用于']"></reason>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm10",
        props: {
            T10: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm
            }
        },
    };
</script>
